<template>
	<div class="starting-idea">
		<speaker-notes :notes="notes"></speaker-notes>
		<h2>Start with an idea</h2>
		<img src="@/assets/images/programmer-with-idea.png" alt="programmer with an idea">
		<p>How would a programmer turn this, ...</p>
	</div>
</template>

<script>
	import SpeakerNotes from "../components/SpeakerNotes";
	export default {
		name: "starting-idea",
		components: {SpeakerNotes},
		data() {
			return {
				notes: [
					"How do you get the browser to produce audio?",
					"1) Create an mp3 on the server in advance,",
					"IF you know what the music will be in advance.",
					"BUT requires an extra server call, which can take a long time.",
				]
			};
		},
	}
</script>

<style lang="scss" scoped>
	.starting-idea {
		text-align: center;
	}
</style>
